// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610221136/js/" + chunkId + "." + {"44":"1dcfc956","225":"bcf85642","481":"face7deb","486":"f096f0bb","770":"15254d83"}[chunkId] + ".0.29914492914247637.chunk.js";
};